import React from 'react';
import TestResultDisplay from '../common/TestResultDisplay';

// 膀胱健康测试响应数据接口
interface UrinaryResponses {
  hasIncontinence?: boolean;
  frequency?: string;
  severity?: string;
  impact?: {
    daily_activities?: boolean;
    sleep_quality?: boolean;
    social_activities?: boolean;
    emotional_wellbeing?: boolean;
  };
}

interface UrinaryTestResultProps {
  responses: UrinaryResponses;
  hasProblem: boolean;
  className?: string;
}

const UrinaryTestResult: React.FC<UrinaryTestResultProps> = ({
  responses,
  hasProblem,
  className = ''
}) => {
  // 🚨 调试标记 - UrinaryTestResult 组件已加载 🚨
  console.log('🚨🚨🚨 UrinaryTestResult 组件已加载 - 2025-08-30 🚨🚨🚨');
  console.log('🔥 responses:', responses);
  console.log('🔥 hasProblem:', hasProblem);


  // 膀胱健康评估：只有一个测试问题，无filter question逻辑
  const testGroups = [
    {
      title: '膀胱健康评估',
      passed: !hasProblem,
      items: [
        {
          name: '尿失禁状况',
          passed: !hasProblem,
          userAnswer: hasProblem ? '有尿失禁问题' : '无尿失禁问题'
        }
      ]
    }
  ];

  return (
    <TestResultDisplay
      title="膀胱健康评估结果"
      subtitle={`综合评估: ${!hasProblem ? '1/1' : '0/1'}项指标正常`}
      testGroups={testGroups}
      className={className}
    />
  );
};

export default UrinaryTestResult;